// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#fff","subMenuActiveText":"#f4f4f5","menuBg":"#001529","menuHover":"#263445","subMenuBg":"#000d17","subMenuHover":"#263445","sideBarWidth":"210px","menuActiveBg":"#9393ff","hoverText":"#9393ff","btnBg":"#9393ff"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 7